/**
 * No-operation function. Useful in specific circumstances,
 * for example: Promise catch when no action is intended.
 */
export default () => undefined;
